import axios from "axios";
import Config from "../utils/Config";

class AuthRestService{
    config = {
        headers: {
          Authorization: "",
          GroupId: "",
          CompanyId: "",
        },
      };

      setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
      }

      async login(formData) {
        const data = await axios.post(
          Config.BACKEND_URL + "/api/auth/login",
          formData,
          this.config
        );
        return data.data;
      }

      async getAllGroups (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + "/api/auth/groupDropDown",
                this.config
            );
            return data.data;
        }
  
      async getAllCompanys (accessToken, groupId, companyId){
        this.setAccessToken(accessToken, groupId, companyId);
            const data = await axios.get(
                Config.BACKEND_URL + `/api/auth/companyDropDown/${groupId}`,
                this.config
            );
            return data.data;
        }

        async forgotPassword (accessToken, groupId, companyId, formData){
          this.setAccessToken(accessToken, groupId, companyId);
              const data = await axios.post(
                  Config.BACKEND_URL + "/api/auth/forgotPassword",
                  formData,
                  this.config
              );
              return data.data;
          }

          async resendForgotPassword(accessToken, groupId, companyId, formData){
            return this.forgotPassword(accessToken, groupId, companyId, formData);
          }

          async resetPassword (accessToken, groupId, companyId, formData){
                const data = await axios.post(
                    Config.BACKEND_URL + `/api/auth/resetPassword/${accessToken}`,
                    formData
                );
                return data.data;
            }

          async firstTimeResetPassword (accessToken, groupId, companyId, formData){
            this.setAccessToken(accessToken, groupId, companyId);
                const data = await axios.post(
                    Config.BACKEND_URL + "/api/auth/initialPasswordUpdate",
                    formData,
                    this.config
                );
                return data.data;
            }
}

export default new AuthRestService();
